import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Multiselect.html?raw';
import on from 'dojo/on';
import topic from 'dojo/topic';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import _InputMultiBase from '../_InputMultiBase/_InputMultiBase';
import { AccessibilityLabelsHelper, ColorHelpers, EntityHelpers, StringHelpers } from "../../../more/Helpers";
//import DataItems = require("DataItems");


interface listValueObject {
    entity: any,
    value: string,
    groupValue?: string,
    label: string,
    secondaryLabel?: string,
    bgColor: string,
    selectable: boolean,
    preselected: boolean,
    _isSingleAutoselected?: boolean
}

interface GroupEntry {
    value: string;
    label: string;
    icon: string;
    bgColor: string;
}

interface option {
    _data: listValueObject
    value: string,
    hexColor: string,
    entity: object,
    optionNode: HTMLElement,
    optionSelectorNode: HTMLElement,
    label: string,
    visible: boolean,
    selected: boolean,
    selectable: boolean
}

interface MultiselectConfigValueList<T = Object> {
    presetValue: any,
    //newEntryCallback?: (callback: newEntryFunction<simpleOptionData<T>>) => void,
    valuelist: Array<T>,
    bSuppressChange?: boolean,
    labelAttribute?: string,
    valueAttribute?: string,
    colorAttribute?: string,
    groupLabelAttribute?: string,
    groupValueAttribute?: string,
    groupColorAttribute?: string
}

type newEntryFunction<T> = (data: T) => void;
interface simpleOptionData<T = any> {
    value: string,
    label: string,
    color?: string | Partial<more.EntityAPIColor>,
    selectable: boolean,
    entityData?: Array<T>,
    doSelect: boolean,
    bSuppressChange?: boolean

}


interface MultiselectConfigPlain<T = any> {
    values: Array<string>,
    labels: Array<string>,
    colors?: Array<string | Partial<more.EntityAPIColor>>,
    //newEntryCallback?: (callTarget: newEntryFunction<simpleOptionData<T>>) => void,
    presetValue?: Array<any> | string | true | Object,
    selectable?: Array<boolean>,
    entityData?: Array<T>,
    bSuppressChange?: boolean
}
class Multiselect extends compose(_InputMultiBase, _LabelInputBase) {
    templateString: any = template;
    //===================== Nodes START
    private outerInput: HTMLInputElement;
    private outerInputOverlay: HTMLElement;
    private input: HTMLInputElement;
    private openDropdownBtn: HTMLElement;
    private dropdownContainer: HTMLElement;
    private controlContainer: HTMLElement;
    private confirmDropdownBtn: HTMLElement;
    private closeDropdownBtn: HTMLElement;
    private scrollContainer: HTMLElement;
    private noResultsContainer: HTMLElement;
    private btnSelectNone: HTMLElement;
    private btnSelectAll: HTMLElement;
    private btnShowSelected: HTMLElement;
    private btnConfirm: HTMLElement;
    private dropDownIcon: HTMLElement;
    private errorMsgNode: HTMLElement;
    private labelContainerFront: HTMLElement;
    labelNode: HTMLElement;
    //===================== Nodes END

    validationMsgNodeContainer = "errorMsgNode";
    private lastSelectedOption: option;
    private lastTouchedOption: option;

    private currentFocus: number = null;

    private isDropdownActive: boolean = false;

    private isShowSelectedMode: boolean = false;
    private isHideSelectedBtn: boolean = false;


    labelAttribute: string = null;
    secondaryLabelAttribute: string = null;
    valueAttribute: string = "ID"; // Vorgabewert
    colorAttribute: string = null; // Vorgabewert
    selectableAttribute: string = null; // Vorgabewert
    suggestionLabelAttribute: string = null;
    addNonExistentOption: boolean = true;
    groupAttribute: string = null;
    groupValueAttribute: string = null;
    groupColorAttribute: string = null;
    filterPath: string = null;
    searchParam: string = null; // name des Parameters im Filter ( => pit-Filter)
    
    private _additionalRequestParameters: object = null; //
    private _autosetSingleValue: boolean | "strict" = false; // den einzig verfügbaren Wert gleich setzen (bei strict: keine Abwahl zulassen)
    private _useGrouping: boolean = false;

    private __request: any = null;
    private __searchDelay: number = null;
    private __confirmDelay: number = null;
    private _isInitialized: boolean = false;
    private _initialSuppressChange: boolean = undefined;
    private _initialValue: any = undefined;
    private _plainvalue: string = null; // zum Vergleichen: was steht im Input nach der Entityauswahl und hat der Benutzer was reingetippt?


    private valueList: Array<listValueObject> = [];
    private groupList: Array<GroupEntry> = [];
    private optionsRegistry: Array<option> = null;// [];
    private _selectedValues: Array<string> = [];
    private _selectedEntities: Array<object> = [];
    private _oldSelection: string | Array<any> = "-x"; // ändert sich auch wenn nach erstem Laden "nichts" gewählt is
    

    //private value: string = null;

    private lastClickedOptions: any = [];

    private url: string = null;
    private callfunction: string = null;

    private limit: number = null;

    confirmSelectionInterval: number = 500;

    /**
    * Fügt dem Request ein Objekt "additionalParameters" ein, das aus den hier eingefügten Properties besteht.
    * @param param Name des Parameters
    * @param value Wert des Parameters
    */
    addAdditionalRequestParameter(param: string, value: any): void {
        if (!this._additionalRequestParameters) {
            this._additionalRequestParameters = {};
        }

        this._additionalRequestParameters[param] = value;
    }

    focus() {
        if (this.isDropdownActive) {
            this.input.focus();
        } else {
            this.outerInput.focus();
        }
        //this.inputNode.focus();
    }

    setMultiselect(bMultiselect: boolean) {
        super.setMultiselect.apply(this, arguments as any);

        this.hideNode(this.selectInfoContainer, !bMultiselect);
        this.hideNode(this.btnSelectAll, !bMultiselect);
        this.UiModder.domClass.toggle(this.domNode, "singleSelect", !bMultiselect);
        this._constructOptions();
    }


    _setPlaceholderAttr(value: string, outerPlaceholder?: string): void {
        this.setOuterPlaceholder(outerPlaceholder);
        this.setPlaceholder(value);
    }

    setOuterPlaceholder(newValue: string) {
        if (newValue && this.canTranslate(newValue)) newValue = this.translate(newValue);
        if (typeof (newValue) != "undefined") {
            if (newValue && this.canTranslate(newValue)) newValue = this.translate(newValue);

            this.placeholderOuterinput = newValue;
        } else {
            this.placeholderOuterinput = null;
        }
        this.setPlaceholderValue();

    }

    private _setOuterPlaceholderAttr(outerPlaceholder: string) {
        this.setOuterPlaceholder(outerPlaceholder);
    }

    private placeholderOuterinput: string = null;

    setPlaceholderValue(newValue?: string) {
        if (newValue && this.canTranslate(newValue)) newValue = this.translate(newValue);
        if (typeof (newValue) != "undefined") this.placeholder = newValue;
        let value = this.placeholder;

        this.UiModder.domAttr.set(this.input, "placeholder", value);
        this.UiModder.domAttr.set(this.outerInput, "placeholder", this.placeholderOuterinput ? this.placeholderOuterinput : value);

    }
    protected _setReadonlyStyle(): void {

        if (this.isReadonly == true) {

            this.UiModder.domAttr.set(this.outerInput, "disabled", "disabled");
            this.UiModder.domAttr.set(this.input, "disabled", "disabled");
        }
        else {
            this.UiModder.domAttr.remove(this.outerInput, "disabled");
            this.UiModder.domAttr.remove(this.input, "disabled");
        }

        //this.disableNode(this.outerInput,this.isReadonly); // bissl overkill
        this.UiModder.domClass.toggle(this.outerInput, "noInteraction", this.isReadonly);

        this.disableNode(this.openDropdownBtn, this.isReadonly);
    }

    /**
     * false: keine automatische Auswahl
     * true: wenn es nur einen Wert in der valuelist gibt, wird dieser gesetzt (mit change-emit)
     * strict: die Dropdownauswahl wird gesperrt, wenn der einzige verfügbare Wert bereits ausgewählt ist
     */
    autosetSingleValue(mode: boolean | "strict") {
        this._autosetSingleValue = mode;
        let disableDropdownContents = false;

        if (this._autosetSingleValue != false) {
            if (this.valueList?.length == 1) {

                if (this._selectedValues.length == 0) {
                    this.setValue(this.valueList[0].value);

                    this.__delayValueChangeEmit(1);
                }

                disableDropdownContents = this._autosetSingleValue == "strict" &&
                    this._selectedValues[0] == this.valueList[0].value
            }
        } else {

        }

        if (this.isReadonly) disableDropdownContents = false;

        //this.disableNode(this.btnSelectNone, disableDropdownContents);
        this.disableNode(this.input, disableDropdownContents);
        this.disableNode(this.controlContainer, disableDropdownContents);
        this.disableNode(this.scrollContainer, disableDropdownContents);
    }

    private _setAutoselectSingleValueAttr(value: boolean | "strict") {
        //this.autosetSingleValue(value);
        this._autosetSingleValue = value;
    }


    //_setMandatoryAttr(value:boolean):void {
    //    this.isMandatory = value;
    //    //this.checkValidity();
    //}

    private showDropdown(bActive: boolean): void {
        if (this.isReadonly == true) {
            return;
        }

        if (bActive !== false) {
            bActive = true;
        }

        if (this.isDropdownActive != bActive) {
            this.isDropdownActive = bActive;
            this.setDropdownStyle();

            if (this.isDropdownActive == true) {
                // die bisherige Auswahl als Backup wegspeichern
                this._oldSelection = [];
                for (var i = 0; i < this._selectedValues.length; i++) {
                    this._oldSelection.push(this._selectedValues[i]);
                }

                if (this.isMultiSelect == false && this._selectedValues?.length == 1) {
                    let opt = this.getOptionByValue(this._selectedValues[0]);
                    if (opt) {
                        opt.optionNode.scrollIntoView({ block: "nearest", behavior: "smooth" });
                    }
                }

                //this.btnSelectNone.scrollIntoView({
                //    behavior: "smooth"
                //    //block: "end",
                //});
            } else {
                this._selectedValues = <any[]>this._oldSelection;
                this.input.value = null;
                this._handleSearch();
            }
        }

        //console.log("_setEditModeAttr", bActive, this._selectedValues);
    }


    /**
     * Einfacher Options-Setter. Aus den values- und labels-Arrays erstellt das Input intern eine Registry und baut das Select auf.
     */
    setOptions(config: MultiselectConfigPlain)
    setOptions(values: Array<string>,
        labels: Array<string>,
        preselected?: Array<any>,
        selectable?: Array<boolean>,
        entityData?: Array<any>,
        bSuppressChange?: boolean)
    setOptions(param1: Array<string> | MultiselectConfigPlain,
        _labels?: Array<string>,
        _preselected?: Array<any>,
        _selectable?: Array<boolean>,
        _entityData?: Array<any>,
        _bSuppressChange?: boolean) {

        let _values = param1 as Array<string>;
        if (typeof (_values) == "object" && !!_values && typeof (_values.length) == "number") {
            this.setOptions({
                values: _values,
                colors: null,
                labels: _labels,
                bSuppressChange: _bSuppressChange,
                entityData: _entityData,
                selectable: _selectable,
                presetValue: _preselected
            })
            return;
        }

        let config = param1 as MultiselectConfigPlain;
        this.setOptionsEx(config);

        //this.setOptionsWithColor(values, labels, null, preselected, selectable, entityData, bSuppressChange);
    }

    setOptionsWithColor(values: Array<string>,
        labels: Array<string>,
        colors: Array<string | Partial<more.EntityAPIColor>>,
        presetValue?: Array<any> | string,
        selectable?: Array<boolean>,
        entityData?: Array<any>,
        bSuppressChange?: boolean) {
        this.setOptionsEx({
            values: values,
            labels: labels,
            colors: colors,
            presetValue: presetValue,
            selectable: selectable,
            entityData: entityData
        },
            bSuppressChange);
    }


    setOptionsEx(config: MultiselectConfigPlain, bSuppressChange?: boolean) {

        if (!config) return;

        let values = config.values;
        let labels = config.labels;
        let colors = config.colors;
        let presetValue = config.presetValue;
        let selectable = config.selectable;
        let entityData = config.entityData;

        if (typeof (bSuppressChange) != "boolean") bSuppressChange = config.bSuppressChange === true;

        this.valueList = [];
        this.groupList = [];
        this._isInitialized = true;
        this._initialValue = undefined;
        this._useGrouping = false;

        let unknownPresetCopy = null;
        if (presetValue) unknownPresetCopy = lang.clone(presetValue);



        //console.debug("multiselect setoptions", values, labels, preselected, selectable);
        if (typeof (unknownPresetCopy) != "undefined") {
            this._selectedEntities = [];
            this._selectedValues = [];
        }


        if (!lang.isArray(unknownPresetCopy)) {
            let preselectedAsObject = unknownPresetCopy as Object;

            if (unknownPresetCopy === true) {
                unknownPresetCopy = lang.clone(values);
            }
            else if (typeof (unknownPresetCopy) == "string") {
                unknownPresetCopy = [unknownPresetCopy];
            }
            // es ist ein einzelnes Objekt:
            else if (unknownPresetCopy && typeof (unknownPresetCopy) == "object") {

                let value = EntityHelpers.getComplexProperty(unknownPresetCopy, this.valueAttribute);
                // ganzes Entity übergeben. nur value rausziehen:
                unknownPresetCopy = value;

            } else {
                unknownPresetCopy = [];
            }
        }

        let preselectedValues: Array<boolean> = [];

        // testen ob im Array booleans stehen oder gewählte Werte
        if (unknownPresetCopy && typeof (unknownPresetCopy.length) == "number" && unknownPresetCopy.length > 0) {

            let testValue = unknownPresetCopy[0];

            // Variante 1: es ist ein Array mit den bool-Werten, das synchron zu den übergebenen values behandelt wird
            if (typeof (testValue) == "boolean") {
                for (let i = 0; i < unknownPresetCopy.length && i < values.length; i++) {
                    // tatsächlich selektierte Werte schon mal vormerken:
                    if (unknownPresetCopy[i] == true) {
                        this._selectedValues.push(values[i]);
                    }
                }
            }

            // Variante 2: es ist ein Array mit gewählten Werten.
            // ein neues Array aufbauen, das gleich lang ist wie die values und vergleichen was selektiert ist:
            if (typeof (testValue) == "string") {
                // neues Array erstellen das booleans enthält
                let newPreselected: Array<boolean> = [];
                for (var i = 0; i < values.length; i++) {
                    let val: string = values[i];
                    let bIsSelected = unknownPresetCopy.indexOf(val, 0) != -1;
                    newPreselected.push(bIsSelected);

                    // tatsächlich selektierte Werte schon mal vormerken:
                    if (bIsSelected) this._selectedValues.push(val);

                }

                preselectedValues = newPreselected;
            }

            // Variante 3: es ist ein Objekt. dann sollte das value-Property drauf enthalten sein?
            else if (typeof (testValue) == "object" && !!testValue && testValue[this.valueAttribute]) {
                // aus dem Array mit Objekten ein flaches string-Array machen.
                unknownPresetCopy = unknownPresetCopy.map(entry => { return entry[this.valueAttribute] });

                // dann weiter wie bei Variante 2:
                let newPreselected: Array<boolean> = [];

                for (var i = 0; i < values.length; i++) {
                    let val: string = values[i];
                    let bIsSelected = unknownPresetCopy.indexOf(val, 0) != -1;
                    newPreselected.push(bIsSelected);

                    // tatsächlich selektierte Werte schon mal vormerken:
                    if (bIsSelected) this._selectedValues.push(val);
                }
            }
        }


        if (!lang.isArray(selectable)) {
            selectable = [];
        }

        if (!lang.isArray(entityData)) {
            entityData = [];
        }

        let bgColors: Array<string> = [];
        if (!lang.isArray(colors)) {
            colors = [];
        }

        for (let colValue of colors) {
            if (colValue) {
                if (typeof (colValue) == "string") {
                    // hexcolor!
                    bgColors.push(colValue);
                } else if ((colValue as more.EntityAPIColor & Object).hasOwnProperty("BackColor")) {
                    bgColors.push(colValue.BackColor?.Hex ? colValue.BackColor.Hex : null);
                }
            } else {
                bgColors.push(null);
            }
        }

        for (let i = 0; i < values.length; i++) {
            let val: string = values[i];
            let lbl: string = labels[i];
            let preselect: boolean = false;
            let enabled: boolean = true;
            let color: string = null;
            let entity = null;
            let group = null;


            if (preselectedValues.length > i) {
                preselect = preselectedValues[i];
            }

            if (selectable.length > i) {
                enabled = selectable[i] === true;
            }

            if (bgColors.length > i) {
                color = bgColors[i];
            }
            if (entityData.length > i) {
                entity = entityData[i];
            }

            //if (groupLabels.length > i) {
            //    group = groupLabels[i];
            //}

            this._addSelectableValue({
                value: val,
                label: lbl,
                secondaryLabel: this.secondaryLabelAttribute && entity && entity[this.secondaryLabelAttribute] ? entity[this.secondaryLabelAttribute] : null,
                selected: preselect,
                selectable: enabled,
                entity: entity,
                bgColorHex: color,
                group: group
            });
        }

        //this._useGrouping = groupLabels?.length == this.valueList?.length && !!this.valueList.length;

        this.handleNonExistentValues(presetValue, false);

        this._constructOptions();

        //console.debug("multiselect valuelist", this.valueList);

        this.confirmSelection(bSuppressChange);
    }

    private _handleNewButtonSetting(callback: (fct: newEntryFunction<any>) => void) {
        if (!callback) {

            return;
        }

        
    }
    //private _newEntryCallback: (fct: newEntryFunction<any>) => void
    //private _onClick_NewEntry(evt) {
    //    if (!this._newEntryCallback) return;

    //    let target = lang.hitch(this, this.setOptionsExf)
    //    this._newEntryCallback()
    //}



    hideBtnShowSelected(bHide: boolean = true) {
        this.hideNode(this.btnShowSelected, bHide);
        this.isHideSelectedBtn = bHide;
    }

    private _addSelectableValue(params: {
        value: string,
        label: string,
        secondaryLabel?: string,
        selected?: boolean,
        selectable?: boolean,
        entity?: any,
        bgColorHex?: string,
        group?: string
    }) {

        let descriptor: listValueObject = {
            bgColor: params.bgColorHex ? params.bgColorHex : null,
            entity: params.entity ? params.entity : null,
            label: params.label,
            secondaryLabel: params.secondaryLabel,
            selectable: params.selectable === false ? false : true,
            preselected: params.selected === true ? true : false,
            value: params.value,
            groupValue: params.group
        };


        this.valueList.push(descriptor);

        if (params.selected === true && this._selectedValues?.indexOf(params.value) == -1) {
            this._selectedValues.push(params.value);
        }
    }

  
    protected _setLabelPosition(position: "front" | "default" | "top") {
        // muss in Childwidgets ausgestaltet werden!
        if (this.labelNode) {
            switch (position) {
                case "default":
                default:
                case "top":
                    this.UiModder.domConstruct.place(this.labelNode, this.domNode, "first");
                    break;

                case "front":
                    this.UiModder.domConstruct.place(this.labelNode, this.labelContainerFront, "first");
                    break;
            }
        }
    }

    setLabel(label: string, searchPlaceholder?: string): void {
        if (this.labelNode) {
            if (label && this.canTranslate(label)) {
                label = this.translate(label);
            }
            this.UiModder.domAttr.set(this.labelNode, "innerHTML", label);
            this.hideNode(this.labelNode, !label);
        }

        if (searchPlaceholder || searchPlaceholder == "") {
            this.setPlaceholder(searchPlaceholder);
        }
    }

    getValue(bReturnEntities?: boolean): Array<any> {
        if (bReturnEntities === true) {
            return this._selectedEntities;
        }

        return this._selectedValues;
    }

    _getValueAttr(bReturnEntities: boolean): Array<any> {
        return this.getValue(bReturnEntities);
    }

    _setValueAttr(values: any, suppressChangeEvent: boolean = false): void {
        this.setValue(values, suppressChangeEvent);
    }

    setValue(values: any, suppressChangeEvent: boolean = false): void {
        values = lang.clone(values);
        //console.log("multiselectbox _setValueAttr", values);

        // noch keine Registrierung aufgebaut, setValue also zu früh im Lifecycle
        if (this._isInitialized != true) {
            //console.trace(this.id +  " setValue while not initialized", values);
            this._initialValue = values;
            this._initialSuppressChange = suppressChangeEvent === true;
            //this._afterLoadCallback = lang.hitch(this, this.setValue, values, suppressChangeEvent);
            return;
        }

        this._selectedValues = [];
        this._selectedEntities = [];


        if (values === true) { // alle wählen
            this.selectAll();
            this.delayedConfirmSelection(suppressChangeEvent, 10);
            return;
        }

        if (typeof (values) == "object") {
            if (lang.isArray(values)) {
                for (let value of values) {
                    let strValue = "";
                    if (typeof (value) == "object" && value[this.valueAttribute]) {
                        strValue = value[this.valueAttribute];
                    } else if (typeof (value) == "string") {
                        strValue = value;
                    }

                    if (value) {
                        this._selectedValues.push(strValue);
                    }
                }
            }
            else {
                this._selectedValues.push(EntityHelpers.getComplexProperty(values, this.valueAttribute));
            }
        } else if (typeof (values) == "string") {
            this._selectedValues.push(values);
        }

        this.handleNonExistentValues(values, true);

        this._adjustSelectionStyle();
        //this.updateCurrentSelectedValues();
        this.delayedConfirmSelection(suppressChangeEvent, 10);

    }

    refreshOptions() {
        this._constructOptions();
    }

    private handleNonExistentValues(anyvalue: any, constructOptions: boolean) {
        if (this.addNonExistentOption && !!anyvalue) {
            if (lang.isArray(anyvalue)) {
                for (let value of anyvalue) {
                    let strValue = "";
                    if (typeof (value) == "object") {
                        strValue = EntityHelpers.getComplexProperty(value, this.valueAttribute)
                    } else if (typeof (value) == "string") {
                        strValue = value;
                    }

                    if (!this.optionExists(strValue)) {
                        this.addUnselectableOption(value);
                    }
                }
            } else {
                if (!this.optionExists(anyvalue)) {
                    this.addUnselectableOption(anyvalue);
                }
            }

            if (constructOptions === true) this._constructOptions();
        }
    }

    optionExists(value: any): boolean {

        let result = -1;
        let argumentValue;
        let registryValue;

        if (typeof (value) == "object") {
            if (lang.isArray(value)) {
                // ?? wie sollen wir ein Array gegenprüfen? müssen alle vorhanden sein? reicht eins?
                return false;
            } else {
                argumentValue = EntityHelpers.getComplexProperty(value, this.valueAttribute);
            }
        } else if (typeof (value) == "string") {
            argumentValue = value;
        }

        for (let valueEntry of this.valueList) {
            let registryValue = valueEntry.value;
            if (registryValue == argumentValue) return true;
        }

        return false;
    }

    private addUnselectableOption(value: any): void {

        if (typeof (value) == "object") {

            this._addSelectableValue({
                value: value[this.valueAttribute],
                label: value[this.labelAttribute],
                secondaryLabel: this.secondaryLabelAttribute ? value[this.secondaryLabelAttribute] : null,
                selected: true,
                selectable: false,
                entity: value
            });

        } else if (typeof (value) == "string") {

            this._addSelectableValue({
                value: value,
                label: value,
                selected: true,
                selectable: false});
        }
    }

    setUrl(newUrl: string) {
        if (newUrl !== null && newUrl !== "" && newUrl !== undefined) {
            this.callfunction = null;
        }

        this.url = newUrl;
    }
    setCallfunction(callfunctionName: string) {
        if (callfunctionName) {
            this.url = null;
        }

        this.callfunction = callfunctionName;
    }

    private _setUrlAttr(url: string): void {
        this.setUrl(url);
    }

    setAddNonExistentOption(value: boolean): void {
        this.addNonExistentOption = value;
    }

    private _setAddNonExistentOptionAttr(value: boolean): void {
        this.setAddNonExistentOption(value);
    }

    private _setOptionHeadingGroupAttributeAttr(value: string, colorAttribute?: string): void {
        this.setOptionHeadingGroupAttribute(value, colorAttribute);
    }
    setOptionHeadingGroupAttribute(value: string, colorAttribute?: string): void {
        this.groupAttribute = value;
        if (typeof (colorAttribute) != "undefined") this.colorAttribute = colorAttribute;

        if (this.valueList?.length) this._constructOptions();
    }
    getOptionHeadingGroupAttribute(): string {
        return this.groupAttribute;
    }

    private getGroupByValue(value: string): GroupEntry {
        for (let group of this.groupList) {
            if (group.value == value) return group;
        }

        return null;
    }
     private getOptionByValue(value: string): option {
        for (let opt of this.optionsRegistry) {
            if (opt.value == value) return opt;
        }

        return null;
    }

    private _loadTimeout: any = null;

    /**
     * True solange der initiale Listen-Load (url/callfunction) noch aussteht bzw. dessen
     * Wert-Echo (delayedConfirmSelection) noch nicht durch ist. Wird von _StatefulSection
     * benutzt, um resetDirty/ready nicht vor dem Echo auszulösen (Race beim Editor-Open,
     * wenn das Entity-Load schneller antwortet als die Listen-Endpoints).
     */
    isInitialListLoadPending(): boolean {
        if (this["_destroyed"] === true) return false; // zerstörtes Widget darf die Section nicht warten lassen
        if (!this.url && !this.callfunction) return false; // kein Listen-Backing
        if (this._isInitialized) {
            return this.__confirmDelay != null; // Optionen gesetzt, Wert-Echo (+10ms confirm) noch in der Queue
        }
        return this.__request != null || this._loadTimeout != null;
    }

    loadListValues(presetValue?: any, bSuppressChangeEvent?: boolean): void {
        if (this._loadTimeout) {
            clearTimeout(this._loadTimeout);
        }

        // falls dojo-startup und ein anderes widget das Load zweimal aufrufen...
        this._loadTimeout = setTimeout(lang.hitch(this, this._startListValuesRequest, presetValue, bSuppressChangeEvent), 50);
    }

    private _startListValuesRequest(presetValue?: any, bSuppressChangeEvent?: boolean) {
        // nicht resetten, evtl wird ein Wert gesetzt und die möglichen Werte danach nachgeladen
        //
        //console.log("multiselect _loadListValues", presetValue);
        if (typeof (presetValue) != "undefined") {
            this._selectedValues = [];// = null;
            this._selectedEntities = [];

            //this.set("value", presetValue);
        }
        else {

            if (this._selectedValues?.length > 0) {
                presetValue = this._selectedValues;
            } else {
                this._selectedValues = [];// = null;
                this._selectedEntities = [];
            }
        }

        //this._adjustCurrentSelectionState();

        var url:string;
        if (this.url == null) {

        } else {
            url = this.url;
        }


        if (this.__request != null) {
            //console.log("selectbox: request cancel");
            if (typeof this.__request.cancel == 'function') {
                this.__request.cancel();
            } else if (typeof this.__request.abort == 'function') {
                this.__request.abort();
            }

            this.__request = null;
        }

        this._loadTimeout = null;


        this.StandbyStart();

        let requestParams: object = {};


        if (this.filterPath != null) {
            requestParams["filterPath"] = this.filterPath;
        }

        if (this.searchParam != null) {
            requestParams["searchParam"] = this.searchParam;
        }

        if (this.limit != null) {
            requestParams["limit"] = this.limit;
        }

        requestParams["labelAttribute"] = this.labelAttribute;

        // Extraparameter
        if (this._additionalRequestParameters != null) {
            for (let key in this._additionalRequestParameters) {
                requestParams[key] = lang.clone(this._additionalRequestParameters[key]);
            }
        }
        if (this.callfunction) {
            this.StandbyStart();
            this.__request = this.RequestManager.callfunction(this.callfunction,
                requestParams,
                lang.hitch(this, this._onLoadListValuesResponse, presetValue, bSuppressChangeEvent),
                lang.hitch(this, this._onLoadListValuesError) as any
            );

        } else if (url) {
            let requestUrl: string = window.appRoot + url;

            //console.log("multiSelectBox _loadListValues", requestUrl, requestParams, presetValue);

            // zwecks Legacy: Searchselect hat beim normalen Post immer fix jsonData mitgegeben
            // die Requestparams also um ein jsonData erweitern, das wiederum die Requestparams enthält...
            let jsonDataStr = JSON.stringify(requestParams);
            requestParams["jsonData"] = jsonDataStr;

            this.__request = this.RequestManager.post(
                requestUrl,
                requestParams,
                lang.hitch(this, this._onLoadListValuesResponse, presetValue, bSuppressChangeEvent),
                lang.hitch(this, this._onLoadListValuesError) as any,
                false // sync
            );
        } else {
            this.StandbyStop();
            alert(this.id + ": no request url oder callfunction for loading values defined!");
        }
    }

    private _onLoadListValuesResponse(presetValue:any, bSuppressChangeEvent: boolean, response:any):void { // responsecallback

        this.__request = null;
        this.isShowSelectedMode = false;

        let responseList = [];
        // ist entweder klassisches pit-Datarray oder json-Array aus API
        if (this.dataFormat == "pit") {
            responseList = response.EntityDataArray;
        } else if (this.dataFormat == "json") {
            responseList = response;
            if (typeof (response) == "string") { // Kompatibilität mit bisher doppelt stringifizierten JSON-Responses
                responseList = JSON.parse(response);
            }
        }

        if (!this.labelAttribute || !this.valueAttribute) {
            alert("multiselectbox nicht bereit: labelattribute und/oder valueattribute nicht gesetzt! - " + this.id);

            this.StandbyStop();

        }

        // falls kein preset und noch in der Initialisierung, Vorgabewert aus _initialValue nehmen. könnte zwischenzeitlich gesetzt worden sein.
        if (!presetValue && !this._isInitialized) {
            presetValue = this._initialValue;
            // falls es ein preset gibt und explizit (!!) ein suppressChange mitgegeben wurde, dann dieses übernehmen, falls nicht anders überschrieben.
            if (presetValue != undefined && typeof (this._initialSuppressChange) == "boolean" && typeof (bSuppressChangeEvent) == "undefined") {
                bSuppressChangeEvent = this._initialSuppressChange;
            }
        }

        this.setData(presetValue, responseList, bSuppressChangeEvent, this.labelAttribute, this.valueAttribute, this.colorAttribute, this.groupAttribute);


        this.emit("listValuesLoaded");
        this.emit("loaded");
        //if (presetValue != null && typeof (presetValue) != "undefined") {
        //    this.setValue(presetValue, bSuppressChangeEvent);
        //    this.confirmSelection(false);
        //}

        this.StandbyStop();


        //this._handleSearch();
    }

    setDropDownPositionAbsolute(bSetAbsolute: boolean) {
        if (bSetAbsolute === false) {
            this.UiModder.domStyle.set(this.dropdownContainer, "position", "static");
        } else {
            this.UiModder.domStyle.set(this.dropdownContainer, "position", "absolute");
        }
    }
    /**
     * Für die bestehende Gruppenregistrierung eine Zuweisung von Icons vornehmen.
     * GroupValues und GroupIcons müssen dieselbe Länge aufweisen, dann wird für jede registrierte Gruppe mit dem Wert aus groupValues das jeweilige Icon aus groupIcons hinterlegt.
     */
    setGroupIcons(groupValues: Array<string>, groupIcons: Array<string>) {

        if (groupValues && groupValues.length == groupIcons?.length) {

        }

        for (let indexGroup = 0; indexGroup < groupValues?.length; indexGroup++) {
            let val = groupValues[indexGroup];
            let icon = groupIcons[indexGroup];
            for (let entry of this.groupList) {
                if (entry.value == val) {
                    entry.icon = icon;
                }
            }
        }

        this._constructOptions();
    }

    /**
     *  Die Länge der Labels muss genau der Länge der verfügbaren Werte entsprechen!
     * @param groupValues Werden alternativ zur Sortierung der Gruppen benutzt, ohne deren Labels zu ändern.
     */
    setOptionGroups(groupLabels: Array<string>, groupValues?: Array<string>, groupColors?: Array<string>, groupIcons?: Array<string>) {
        if (groupLabels.length < this.valueList.length) return;

        for (let i = 0; i < this.valueList.length; i++) {
            let entry = this.valueList[i];

            if (!groupValues?.length) {
                groupValues = lang.clone(groupLabels);
            }
            entry.groupValue = groupValues[i];
        }

        this.groupList = [];

        for (let i = 0; i < groupLabels.length; i++) {
            let group: GroupEntry = {
                label: groupLabels[i],
                value: groupValues[i],
                bgColor: groupColors[i],
                icon: groupIcons[i],
            };

            if (groupColors.length > i) group.bgColor = groupColors[i];
            if (groupIcons.length > i) group.icon = groupIcons[i];

            this.groupList.push(group);
        }


        this._useGrouping = groupLabels.length == this.valueList.length;
        this._constructOptions();
    }
    setup(config: MultiselectConfigValueList) {

    }
    setData(config: MultiselectConfigValueList): void
    setData(presetValue: any,
        valuelist: Array<Object>,
        bSuppressChange?: boolean,
        labelAttribute?: string,
        valueAttribute?: string,
        colorAttribute?: string,
        groupLabelAttribute?: string,
        groupValueAttribute?: string,
        groupColorAttribute?: string): void
    setData(_presetValue: any,
        _valuelist?: Array<Object>,
        _bSuppressChange?: boolean,
        _labelAttribute?: string,
        _valueAttribute?: string,
        _colorAttribute?: string,
        _groupLabelAttribute?: string,
        _groupValueAttribute?: string,
        _groupColorAttribute?: string): void {

        let config: MultiselectConfigValueList = _presetValue;

        if (config && typeof (config) == "object" && Object.keys(config).indexOf("presetValue") != -1 && Object.keys(config).indexOf("valueList") != -1) {

        } else {
            if (_valuelist && typeof (_valuelist.length) == "number") {
                config = {
                    presetValue: _presetValue,
                    valuelist: _valuelist,
                    bSuppressChange: _bSuppressChange,
                    colorAttribute: _colorAttribute,
                    groupColorAttribute: _groupColorAttribute,
                    groupLabelAttribute: _groupLabelAttribute,
                    groupValueAttribute: _groupValueAttribute,
                    labelAttribute: _labelAttribute,
                    valueAttribute: _valueAttribute
                };

                this.setData(config);
                return;
            }
        }


        if (config.labelAttribute) this.labelAttribute = config.labelAttribute;
        if (config.valueAttribute) this.valueAttribute = config.valueAttribute;
        if (config.colorAttribute) this.colorAttribute = config.colorAttribute;
        if (config.groupLabelAttribute) {
            this.groupAttribute = config.groupLabelAttribute;
        }

        _bSuppressChange = config.bSuppressChange === true;

        if (config.groupValueAttribute) this.groupValueAttribute = config.groupValueAttribute;
        if (config.groupColorAttribute) this.groupColorAttribute = config.groupColorAttribute;


        config.groupLabelAttribute = this.groupAttribute;
        config.groupValueAttribute = this.groupValueAttribute;
        config.groupColorAttribute = this.groupColorAttribute;


        if (!lang.isArray(config.valuelist)) {
            config.valuelist = [];
        }



        let values = [];
        let labels = [];
        let selectables = [];
        let selected = [];
        let colors = [];
        let entities = [];

        let groupLabels = [];
        let groupValues = [];
        let groupColors = [];
        let groupIcons = [];

        for (let unknown of config.valuelist) {
            let color = null;
            let value = null;
            let label = null;

            let selectable: boolean = true;

            let groupLabel = null;
            let groupValue = null;
            let groupColorBg = null;

            if (typeof (unknown) == "object" && !!unknown) {
                value = EntityHelpers.getComplexProperty(unknown, this.valueAttribute);

                label = EntityHelpers.getComplexProperty(unknown, this.labelAttribute);
                if (!label) label = value;

                if (config.groupLabelAttribute) {
                    let val = EntityHelpers.getComplexProperty(unknown, config.groupLabelAttribute);
                    if (val) {
                        if (typeof (val) == 'number'){
                            val = String(val);
                        }
                        if (typeof (val) == "string") {
                            groupLabel = val;
                        }
                    }

                    if (config.groupValueAttribute) {
                        let val = EntityHelpers.getComplexProperty(unknown, config.groupValueAttribute);
                        if (val) {
                            if (typeof (val) == "string") {
                                groupValue = val;
                            }
                        }
                    } else {
                        groupValue = groupLabel
                    }

                    if (config.groupColorAttribute) {
                        if (unknown.hasOwnProperty(config.groupColorAttribute)) {
                            let colorValue = unknown[config.groupColorAttribute] as more.EntityAPIColor & Object | string;
                            if (colorValue) {
                                if (typeof (colorValue) == "string") {
                                    groupColorBg = colorValue;
                                } else if (colorValue.hasOwnProperty("pitBGR")) {
                                    groupColorBg = colorValue;
                                }
                            }
                        } else {
                            let colorValue = EntityHelpers.getComplexProperty(unknown, config.groupColorAttribute);
                            if (colorValue) {
                                if (typeof (colorValue) == "string") {
                                    groupColorBg = colorValue;
                                } else if (colorValue.hasOwnProperty("pitBGR")) {
                                    groupColorBg = colorValue;
                                }
                            }
                        }

                    }
                }

                color = null;
                if (this.colorAttribute) {
                    if (unknown.hasOwnProperty(this.colorAttribute)) {
                        let colorValue = unknown[this.colorAttribute] as more.EntityAPIColor & Object | string;
                        if (colorValue) {
                            if (typeof (colorValue) == "string") {
                                color = colorValue;
                            } else if (colorValue.hasOwnProperty("pitBGR")) {
                                color = colorValue;
                            }
                        }
                    } else {
                        let colorValue = EntityHelpers.getComplexProperty(unknown, this.colorAttribute);
                        if (colorValue) {
                            if (typeof (colorValue) == "string") {
                                color = colorValue;
                            } else if (colorValue.hasOwnProperty("pitBGR")) {
                                color = colorValue;
                            }
                        }
                    }
                }

                selectable = true;
                if (this.selectableAttribute) {
                    selectable = EntityHelpers.getComplexProperty(unknown, this.selectableAttribute) !== false;
                }

                entities.push(unknown);

            } else if (typeof(unknown) == "string") {
                // ??? was sollma damit
                value = unknown;
                label = unknown;
                entities.push(null);
            }

            groupLabels.push(groupLabel);
            groupValues.push(groupValue);
            groupColors.push(groupColorBg);

            colors.push(color);
            values.push(value);
            labels.push(label);
            selectables.push(selectable);
        }
        
        this.setOptionsEx({
            values: values,
            labels: labels,
            colors: colors,
            bSuppressChange: _bSuppressChange,
            presetValue: config.presetValue,
            selectable: selectables,
            entityData: entities,
            //newEntryCallback: config.newEntryCallback
        });


        if (config.groupLabelAttribute) {
            this.setOptionGroups(groupLabels, groupValues, groupColors, groupIcons);
        }

        if (this._autosetSingleValue) this.autosetSingleValue(this._autosetSingleValue);

    //    this._constructOptions();

    //    if (presetValue != null && typeof (presetValue) != "undefined") {
    //        this.setValue( presetValue, bSuppressChange);
    //        //this.confirmSelection(false); // ORIGINAL
    //        this.confirmSelection(bSuppressChange);
    //    }
    }

    getAllValues(returnEntities?: boolean): Array<object> {
        if (returnEntities) {
            return this.valueList?.map(entry => entry.entity);
        }
        return this.valueList;
    }

    private _onLoadListValuesError(err: string | more.requestErrorMessage): void { // errorCallback

        this.__request = null;
        if (typeof (err) == "object") {
            alert(err.Message);
            console.error("_onLoadListValuesError ", err.Message);
        } else {
            alert(err);
            console.log("_onLoadListValuesError ", err);
        }
        this.StandbyStop();
    }

    private _constructOptionHeader(value: string, label: string, colorHex?: string, iconClass?: string): void {

        let groupLabel = label; // EntityHelpers.getComplexProperty(entity, this.groupAttribute);


        if (!groupLabel) { // nicht zugeordnete ("lose") entities ohne heading : label == null
            groupLabel = "---";
            let hr = this.UiModder.domConstruct.create("hr");
            groupLabel = hr.outerHTML;
        }


        let currentSearchValue: string = null;
        if (this.input.value && this.input.value != "" && this.input.value != null) {
            currentSearchValue = this.input.value.toLowerCase()
        }
        let bShow: boolean = true;


        let option: HTMLElement = this.UiModder.domConstruct.create("div", { className: "groupLabel" }, this.scrollContainer);
        let icon = this.createFontawesomeIcon("fas fa-circle invisible", "", option);

        if (colorHex && colorHex.length >= 3) {
            let isDark = ColorHelpers.isDarkColor(colorHex);
            this.UiModder.domClass.toggle(option, "darkBG", isDark === true);

            option.style.setProperty("--bgColor", colorHex);
            this.UiModder.domClass.add(option, "colored");

        }

        if (iconClass) {
            this.UiModder.domClass.remove(icon);
            this.UiModder.domClass.add(icon, iconClass);
        }

        this.UiModder.domClass.add(option, "flex_row_center nowrap item");

        if (bShow != true) {
            this.UiModder.domClass.add(option, "w3-hide");
        }

        if (this.isMultiSelect) {
            on(option, "click", lang.hitch(this, this._onClick_Group, value))
            this.UiModder.domClass.add(option, "hoverDark");
        }

        let optionLabel: HTMLElement = this.UiModder.domConstruct.create("div", { innerHTML: groupLabel, style: { "flex": "1" } }, option);
        this.UiModder.domClass.add(optionLabel, "label");
    }


    private _constructOptions(bUpdateSelection?: boolean): void {
        this.UiModder.domConstruct.empty(this.scrollContainer);

        this.disableNode(this.btnShowSelected, this._selectedValues?.length < 1 && this.isShowSelectedMode != true);


        this.optionsRegistry = [];
        //console.log("Multiselect _constructOptions", this._selectedValues, this.valueList);

        let valuelist = lang.clone(this.valueList);
        if (this._useGrouping) {
            valuelist.sort((entryA, entryB) => {
                if (entryA.groupValue != null && entryB.groupValue != null) {
                    return entryA.groupValue.localeCompare(entryB.groupValue);
                } else if (entryA.groupValue == null) return -1;
                return 1;
            })
        }

        var bOnlySelected: boolean = this.isShowSelectedMode == true;
        let previousGroupValue = "-xxx11222$";
        let currentSearchValue: string = null;
        if (this.input.value && this.input.value != "" && this.input.value != null) {
            currentSearchValue = this.input.value.toLowerCase()
        }
        // aus den geladenen Daten die selects erstellen
        if (valuelist != null) {
            for (let valueEntry of valuelist) {


                let value: any = valueEntry.value;
                if (value == "" || value == null) continue;

                try {
                    value = value.toString();
                } catch (ex) {

                }

                let label: string = valueEntry.label;
                let selectable: boolean = valueEntry.selectable !== false;

                let secondaryLabel: string = valueEntry.secondaryLabel


                let colorValue = valueEntry.bgColor;

                var bShow: boolean = true;
                let bIsSelected = this._selectedValues.indexOf(value, 0) != -1;

                let entity = valueEntry.entity;

                bShow = bOnlySelected != true || bIsSelected;

                // wenn eine Suche eingetragen ist...
                if (currentSearchValue) {
                    //if (label.toLowerCase().includes(this.input.value.toLowerCase(), 0)) { // includes does not exist on type string sagt er...
                    if (label.toLowerCase().indexOf(currentSearchValue) != -1) {

                    } else if (secondaryLabel &&
                        secondaryLabel.toLowerCase().indexOf(currentSearchValue) != -1) {

                    }
                    else {
                        bShow = false;
                    }
                }

                let option: HTMLElement;
                let optionSelector: HTMLElement;

                if (bShow) {
                    let groupValue = "";
                    if (this.groupAttribute) {
                        groupValue = valueEntry.groupValue;

                        if (groupValue != previousGroupValue) {
                            let groupLabel = groupValue;
                            let groupIcon = null;
                            let groupColor = null;
                            for (let groupentry of this.groupList) {
                                if (groupentry.value == groupValue) {
                                    groupLabel = groupentry.label;
                                    groupIcon = groupentry.icon;
                                    groupColor = groupentry.bgColor;
                                }
                            }
                            //create header
                            this._constructOptionHeader(groupValue, groupLabel, groupColor, groupIcon);
                            previousGroupValue = groupValue;
                        }
                    }

                    option = this.UiModder.domConstruct.create("div", { className: "hoverDark" }, this.scrollContainer);

                    if (!!colorValue && colorValue.length >= 3) {
                        option.style.setProperty("--bgColor", colorValue);
                        this.UiModder.domClass.add(option, "colored");
                    }

                    this.UiModder.domClass.toggle(option, "selected", bIsSelected);
                    this.UiModder.domClass.toggle(option, "selectable", selectable);

                    //domClass.add(option, "selectbox-items");
                    this.UiModder.domClass.add(option, "flex_row_center nowrap item");

                    if (bShow != true) {
                        this.UiModder.domClass.add(option, "w3-hide");
                    }

                    optionSelector = this.UiModder.domConstruct.create("div", { innerHTML: "" }, option);
                    let icon = this.UiModder.domConstruct.create("i", { "ariaHidden": true }, optionSelector);

                    // unterschiedliche Iconsets für Multi- und Singleselect:
                    if (this.isMultiSelect) {
                        this.UiModder.domClass.toggle(icon, "far fa-circle", !bIsSelected);
                        this.UiModder.domClass.toggle(icon, "fas fa-check-circle", bIsSelected);
                    } else {
                        this.UiModder.domClass.toggle(icon, "fas fa-dot w3-opacity", !bIsSelected);
                        this.UiModder.domClass.toggle(icon, "far fa-check", bIsSelected);
                    }



                    this.UiModder.domClass.add(optionSelector, "icon");

                    let optionLabel: HTMLElement = this.UiModder.domConstruct.create("div", { innerHTML: label, style: { "flex": "1" } }, option);
                    this.UiModder.domClass.add(optionLabel, "label");

                    if (secondaryLabel) {
                        secondaryLabel = StringHelpers.stringReplaceAll(secondaryLabel, "\n", "<br>");
                        let slabel = this.UiModder.domConstruct.create("span", {
                            innerHTML: secondaryLabel,
                            className: "w3-block w3-tiny secondaryLabel"
                        }, optionLabel, "last");
                    }


                    //if (this.selectableAttribute != null && this.PitHelper.getEntityAttributeValue(entity, this.selectableAttribute) != true) {
                    //    // Eintrag ist nicht selektierbar!
                    //    this.UiModder.domClass.remove(option, "hoverDark");
                    //    this.UiModder.domClass.add(option, "w3-disabled");

                    //    //domClass.remove(optionLabel, "hoverDark");
                    //    //domClass.add(optionLabel, "w3-disabled");
                    //} else if (this.selectableAttribute != null && this.PitHelper.getEntityAttributeValue(entity, this.selectableAttribute) == true) {

                    //}

                }



                    var registryEntry: option = {
                        value: value,
                        entity: entity,
                        optionNode: option ? option : null,
                        optionSelectorNode: optionSelector ? optionSelector : null,
                        label: label,
                        visible: bShow,
                        selected: bIsSelected,
                        selectable: selectable,
                        hexColor: valueEntry.bgColor,
                        _data: valueEntry
                    };
                    this.optionsRegistry.push(registryEntry);

                if (option) {

                    if (selectable) {
                        this.UiModder.domClass.add(option, "hoverDark");
                        on(option, "click", lang.hitch(this, this._onClick_Option, registryEntry));
                    } else {
                        this.UiModder.domClass.add(option, "w3-disabled");
                    }
                }

            }

            this.entries = this.optionsRegistry;

            if (bUpdateSelection !== false && bUpdateSelection !== true) {
                bUpdateSelection = true;
            }

            //this.set("value";
            this._adjustSelectionStyle();

            if (bUpdateSelection == true) {
                this.updateCurrentSelectedValues();
            }
        }
    }

    private delayedHandleSearch():void {
        if (this.__searchDelay != null) {
            clearTimeout(this.__searchDelay);
            this.__searchDelay = null;
        }

        this.__searchDelay = setTimeout(lang.hitch(this, this._handleSearch), 200);
    }


    private _handleSearch():void {

        this.__searchDelay = null;

        this._constructOptions(false);
    }


    private updateCurrentSelectedValues(): void {
        if (this.optionsRegistry) {
            this._selectedValues = [];
            this._selectedEntities = [];
        }
        let textValue: string = "";
        this.UiModder.domConstruct.empty(this.outerInputOverlay);
        this.UiModder.domClass.remove(this.outerInputOverlay, "crowded");
        if (this.optionsRegistry) {
            let countVisible = 0;
            for (var i = 0; i < this.optionsRegistry.length; i++) {
                let option: option = this.optionsRegistry[i];

                if (option.selected == true) {
                    if (this._selectedValues.indexOf(option.value) === -1) {
                        this._selectedValues.push(option.value);
                        this._selectedEntities.push(option.entity);
                    }


                    if (this._selectedValues.length > 1) {
                        textValue = textValue + ", ";
                    }

                    textValue = textValue + option.label;
                    if (option.visible) {
                        countVisible++;

                        if (countVisible == 10) {
                            this.UiModder.domClass.add(this.outerInputOverlay, "crowded");
                        }
                        if (countVisible < 30 /* irgendwann is auch mal schluss...*/) {
                            let valueBobble = this.UiModder.domConstruct.create("div", {
                                className: "valueDisplay",
                                innerHTML: option.label,
                                title: option.label,
                            }, this.outerInputOverlay);

                            if (option.hexColor) {
                                valueBobble.style.setProperty("--bgColor", option.hexColor);
                                let useDarkTextColor = true;
                                try {
                                    useDarkTextColor = this.useDarkTextColor(option.hexColor);
                                } catch (e) {
                                    console.warn(e);
                                }
                                if (useDarkTextColor) { // weil --bright zu unverlaesslich ist
                                    valueBobble.style.color = "#000"
                                } else {
                                    valueBobble.style.color = "#fff";
                                }
                            }
                        }
                    }
                }
            }
        }
        //textValue = `(${this._selectedValues.length}) ${textValue}`;

        this.outerInput.value = textValue;
        //this.value = this._selectedValues.toString();
        this._value = this._selectedValues.toString(); //this.value;

        this.currentSelect = this._selectedValues;

        this.autosetSingleValue(this._autosetSingleValue);
    }

    protected _adjustSelectionStyle(targetOption?:option):void {
        var optionsList: option[] = this.optionsRegistry;

        if (typeof (targetOption) != "undefined") {
            optionsList = [targetOption];
        }

        var countVisible = 0;

        if (optionsList) {
            for (var i = 0; i < optionsList.length; i++) {
                var option: option = optionsList[i];
                option.selected = false;

                let icon = this.createFontawesomeIcon("fas");

                this.UiModder.domClass.toggle(icon, "far fa-circle", this.isMultiSelect);
                this.UiModder.domClass.toggle(icon, "fas fa-check hidden", !this.isMultiSelect);

                if (this._selectedValues.indexOf(option.value, 0) != -1) {
                    if (this.isMultiSelect) {
                        this.UiModder.domClass.replace(icon, "fas fa-check-circle", "far fa-circle");
                    } else {
                        this.UiModder.domClass.remove(icon, "hidden");
                    }

                    option.selected = true;
                }

                if (option.visible == true) {
                    countVisible++;
                }

                if (option.optionSelectorNode) this.UiModder.domConstruct.place(icon, option.optionSelectorNode, "only");

                if (option.optionNode) this.UiModder.domClass.toggle(option.optionNode, "selected", option.selected);
            }
        }
        this.hideNode(this.noResultsContainer, countVisible != 0);
        this.hideNode(this.scrollContainer, countVisible == 0);

        if (this.isMultiSelect) {
            this.drawSelectInfoLabel(this.entries.length, this._selectedValues.length, true);
        }
    }
    private _onGlobalClick(evt) {
        if (evt && evt["sourceId"]) {
            if (evt["sourceId"] == this.id) {
                return;
            }
        }
        if (this.isDropdownActive) {
            this.toggleDropdown(false);
        }
    }

    private _setupEventListener():void {

        //  click irgendwo im dokument schließt die vorschläge
        //
        //document.addEventListener("click", lang.hitch(this, function (e) {
        //    this.toggleEditmode(false);
        //}));
        //document.addEventListener("click", lang.hitch(this, "toggleEditmode", false));

        this.addSubscription("/Global/Click", lang.hitch(this, this._onGlobalClick));
        this.addSubscription("/Global/CloseModalMenus", lang.hitch(this, this._onGlobalClick));

        on(this.domNode, "keyDown", lang.hitch(this, this._onKeyDown_DomNode));
    //    on(this.domNode, "click", lang.hitch(this, function (e) {
    //        e.stopPropagation();
    //    }))
    }

    private _onKeyDown_Input(evt: KeyboardEvent) {
        var x: HTMLElement | HTMLCollectionOf<HTMLElement> = this.scrollContainer;
        if (this.isReadonly) return;

        if (x) x = x.getElementsByTagName("div");
        if (evt.key == "ArrowDown") {
            this.currentFocus++;

        } else if (evt.key == "ArrowUp") { //up
            this.currentFocus--;

        } else if (evt.key == "Enter") {

            if (!this.__searchDelay) {
                evt.preventDefault();
                this.selectAll();
            }
            if (this.currentFocus > -1) {
                //  focus auf item gesetzt
                //
                //if (x) x[this.currentFocus].click();
            } else {
                //  kein focus auf item
                //
                //if (x.length == 1) {
                //    x[0].click();
                //}
            }
        } else if (evt.key == "Escape" || evt.key == "Esc") {
            if (this.input.value) {
                this.input.value = null;
                this._handleSearch();
                return;
            } else {
                this.toggleDropdown(false);
            }
        }
    }

    // wenn ein Benutzer einen Hint auswählt, aber danach die Inputbox ändert, kann evtl ja die ganze Auswahl ungültig sein
    // deswegen einmalig ein Event auslösen
    private _onKeyUp_Input(evt: KeyboardEvent): void {
        if (this.isReadonly) return;
        if (evt.key == "Enter") {
            evt.stopPropagation();
            if (this.__searchDelay) {
                clearTimeout(this.__searchDelay);
            }
            this._handleSearch();
            return;
        }
        this.delayedHandleSearch();
    }
    private _onKeyDown_DomNode(evt: KeyboardEvent): void {
        // geht ned ? komme nicht bis hierher...
    }

    private _onKeydownDropdown(evt: KeyboardEvent) {
        try {
            let target = evt.target as HTMLElement;
            if (evt.key == "ArrowUp") {
                (target.previousElementSibling as HTMLElement).focus();
                evt.preventDefault();
                evt.stopPropagation();
            }

            else if (evt.key == "ArrowDown") {
                (target.nextElementSibling as HTMLElement).focus();
                evt.preventDefault();
                evt.stopPropagation();
            }
            else if (evt.key == "Escape") {
                this.toggleDropdown(false);
                evt.stopPropagation();
            }
        } catch (ex) {

        }
    }
    private _onKeydownOption(option: option, evt: KeyboardEvent) {
        try {
            if (evt.key == " " || evt.key == "Enter") {
                this._onClick_Option(option, evt as any);
                evt.stopPropagation();
            } else if (evt.key == "Escape") {
                this.toggleDropdown(false);
            }
        } catch (ex) {

        }
    }

    private _onClick_InnerInput(evt: MouseEvent) {
        evt.stopPropagation();
    }

    private _onClick_DropdownContainer(evt: MouseEvent) {
        evt.stopPropagation();
    }

    private _onClick_OuterInput(evt: MouseEvent): void {
        // wenn möglich: bei Klick ins Eingabefeld gleich in den "Editiermodus" wechseln
        this.toggleDropdown(true);
        if (evt) {
            evt["sourceId"] = this.id;
            evt.stopPropagation();

            topic.publish("/Global/CloseModalMenus", evt);
        }
    }

    private _onKeyDown_OuterInput(evt: KeyboardEvent): void {
        if (!this.isDropdownActive && this.isReadonly != true) {
            this.toggleDropdown(true);
            this.input.focus();
        }
    }

    private _onClick_DropDown(evt: MouseEvent):void {
        this.toggleDropdown();
        if (evt) {
            evt["sourceId"] = this.id;
            evt.stopPropagation();

            topic.publish("/Global/CloseModalMenus", evt);
        }
    }

    private toggleDropdown(targetState?: boolean): void {
        if (!this.outerInput) return; // wenn das Ding destroyed ist, dann kommt trotzdem immer wieder der Klick daher, bis der Outerinput plötzlich doch fehlt.

        this.dropDownIcon && this.UiModder.domClass.remove(this.dropDownIcon, "fa-times");
        this.dropDownIcon && this.UiModder.domClass.add(this.dropDownIcon, "fa-caret-up");



        if (typeof (targetState) == "undefined") {
            targetState = this.isDropdownActive !== true;
        }

        if (targetState === true) {
            this.showDropdown(true);
            this.setReadyForConfirmSelection(false);
        } else {
            //this.confirmSelection(false);
            this.showDropdown(false);

            this._selectedValues = <any[]>this._oldSelection;
            this.updateCurrentSelectedValues();
        }
    }

    private setDropdownStyle():void {

        this.hideNode(this.dropdownContainer, !this.isDropdownActive);

        this.disableNode(this.outerInput, this.isDropdownActive);
        this.disableNode(this.input, !this.isDropdownActive);

        if (this.isDropdownActive == true) {
            this.input.focus();
            this.hideNode(this.btnShowSelected, this.valueList?.length <= 1 || this.isHideSelectedBtn);

            this.input.scrollIntoView({ behavior: "smooth", block: "nearest"/*, inline: "nearest"*/ });
        }
    }

    private _onClick_Group(groupvalue: string, evt: MouseEvent) {
        if (!this.isMultiSelect) return;

        let group: GroupEntry = this.getGroupByValue(groupvalue);
        let groupHasSelection: boolean = false;

        if (!group) return;
        for (let value of this._selectedValues) {
            let entry = this.getOptionByValue(value);
            if (entry._data.groupValue == groupvalue && entry.selected) {
                groupHasSelection = true;

                this.selectOption(entry, false);
            }
        }

        if (groupHasSelection) return;

        for (let entry of this.optionsRegistry) {
            if (entry._data.groupValue == groupvalue) {
                this.selectOption(entry, true);
            }
        }
    }

    private _onClick_Option(option: option, evt: MouseEvent): void {

        if (this.isReadonly === true) {
            return;
        }

        if (evt) {
            evt["sourceId"] = this.id;
            evt.stopPropagation();

            //topic.publish("/Global/CloseModalMenus", evt);
        }

        if (this._selectedValues?.length && this.isMultiSelect != true) {
            for (let value of this._selectedValues) {
                if (value != option.value) {
                    let selectedOption = this.getOptionByValue(value);

                    if (selectedOption) this.selectOption(selectedOption, false);
                }
            }

        }

        if (this.isMultiSelect || option.selected != true || this.isMandatory != true) {
            this.selectOption(option, !option.selected);
        }
    }

    private selectOption(option: option, targetState: boolean) {
        if (targetState === true) {
            this.lastSelectedOption = option;
        }

        this.lastTouchedOption = option;


        option.selected = targetState;

        this.updateCurrentSelectedValues();
        this._adjustSelectionStyle(option);



        if (this.isMultiSelect) {
            this.setReadyForConfirmSelection(true);
        } else {
            this.delayedConfirmSelection(false, 10);
        }

        //console.log("selectOption", option, this._selectedValues);
    }

    private _onClick_ShowSelected(evt: MouseEvent): void {
        evt.stopPropagation();
        this.isShowSelectedMode = !this.isShowSelectedMode;

        this._constructOptions();

        this.UiModder.domClass.toggle(this.btnShowSelected, "active", this.isShowSelectedMode);

        if (evt) {
            evt["sourceId"] = this.id;
            evt.stopPropagation();

            topic.publish("/Global/CloseModalMenus", evt);
        }

    }

    private _onClick_Confirm(evt: MouseEvent):void {
        if (this.isReadonly === true) {
            return;
        }
        this.updateCurrentSelectedValues();
        this.delayedConfirmSelection(false, 100);

        if (evt) {
            evt["sourceId"] = this.id;
            evt.stopPropagation();

            topic.publish("/Global/CloseModalMenus", evt);
        }
    }
    private setReadyForConfirmSelection(target?: boolean) {
        this.hideNode(this.btnConfirm, !this.isMultiSelect);

        this.disableNode(this.confirmDropdownBtn, target != true);
        this.hideNode(this.confirmDropdownBtn, target != true);
        this.UiModder.domClass.toggle(this.confirmDropdownBtn, "accentBG", target == true);

        this.UiModder.domClass.toggle(this.btnConfirm, "accentBG", target == true);
        this.disableNode(this.btnConfirm, target != true);

        this.disableNode(this.btnConfirm, target != true);

        if (target === false) {
            this.UiModder.domClass.replace(this.dropDownIcon, "fa-caret-up", "fa-times fa-caret-down");
        } else {
            this.UiModder.domClass.replace(this.dropDownIcon, "fa-times", "fa-caret-up fa-caret-down");
        }
    }

    private delayedConfirmSelection(bSuppressChange:boolean, delay?:number):void {
        if (typeof (delay) != "number") {
            delay = this.confirmSelectionInterval;
        }

        if (this.__confirmDelay != null) {
            clearTimeout(this.__confirmDelay);
            this.__confirmDelay = null;
        }

        this.__confirmDelay = setTimeout(lang.hitch(this, this.confirmSelection, bSuppressChange), delay);
    }

    confirmSelection(bSuppressChange?: boolean): void {
        if (this._destroyed) return;

        let oldValuestxt:string = this._oldSelection.toString();
        let newValuestxt: string = this._selectedValues.toString();

        if (this.__confirmDelay != null) {
            clearTimeout(this.__confirmDelay);
        }
        this.__confirmDelay = null;
        this.updateCurrentSelectedValues();

        this.validateInput();

        //this._selectedEntities = [];
        //for (let option of this.optionsRegistry) {
        //    if (option.selected == true) {
        //        this._selectedEntities.push(option.entity);
        //    }
        //}

        if (newValuestxt != oldValuestxt && bSuppressChange != true) {
            this.emit("change", this._selectedValues);
            this.emit("valueChange", this._selectedValues);
            //alert("new value: " + newValuestxt);
        }

        this._oldSelection = this._selectedValues;

        this.toggleDropdown(false);


        //this.set("editMode", false);
    }

    private _onClick_SelectNone(evt?: MouseEvent): void {
        if (evt) evt.stopPropagation();
        if (this.isReadonly === true) {
            return;
        }
        if (this.optionsRegistry) {
            for (var i = 0; i < this.optionsRegistry.length; i++) {
                let option = this.optionsRegistry[i];
                if (option.selectable !== false) {
                    this.selectOption(option, false);
                }
            }
        }
    }

    private _onClick_SelectAll(evt: MouseEvent): void {
        evt.stopPropagation();
        if (this.isReadonly === true) {
            return;
        }

        this.selectAll();
    }

    private useDarkTextColor(hexColor: string): boolean {
        const hex = hexColor.replace('#', '');
        let r: number, g: number, b: number;
        if (hex.length === 6) {
            r = parseInt(hex.substring(0, 2), 16);
            g = parseInt(hex.substring(2, 4), 16);
            b = parseInt(hex.substring(4, 6), 16);
        }
        else if (hex.length === 3) {
            r = parseInt(hex[0] + hex[0], 16);
            g = parseInt(hex[1] + hex[1], 16);
            b = parseInt(hex[2] + hex[2], 16);
        }
        else {
            return true;
        }
        const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return yiq >= 128;
    }

    selectAll(): void {
        if (this.optionsRegistry) {
            for (var i = 0; i < this.optionsRegistry.length; i++) {
                if (this.optionsRegistry[i].visible === true && this.optionsRegistry[i].selectable) {
                    this.selectOption(this.optionsRegistry[i], true);
                }
            }
        }
    }

    _setIsBtnSelectNoneVisibleAttr(bool: boolean): void {
        this.setIsBtnvisible(this.btnSelectNone, bool);
    }

    _setIsBtnSelectAllVisibleAttr(bool: boolean): void {
        this.setIsBtnvisible(this.btnSelectAll, bool);
    }

    setIsBtnvisible(btn: HTMLElement, bVisible: boolean): void {
        let method: Function = bVisible ? this.UiModder.domClass.remove : this.UiModder.domClass.add;
        method(btn, "w3-hide");
    }

    _setIsHideSelectedBtnAttr(bool: boolean): void {
        this.hideBtnShowSelected(bool);
    }

    _setConfirmSelectionIntervalAttr(number: number): void {
        this.setConfirmSelectionInterval(number);
    }

    setConfirmSelectionInterval(number: number): void {
        this.confirmSelectionInterval = number;
    }

    

    protected customValidation(data?): boolean {
        //console.debug("multiselect customValidation", this._selectedValues);
        if (this.isMandatory != true) {
            this.isValid = true;
        } else if (this._selectedValues && typeof (this._selectedValues.length) == "number") {
            this.isValid = this._selectedValues.length > 0 ;
        }

        return this.isValid;
    }

    postMixInProperties(): void {
        this.isMultiSelect = true;
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate():void {
        super.postCreate.apply(this, arguments as any);
        if (this.canTranslate("General_DefaultPlaceholder_Search")) {
            this.placeholder = this.translate("General_DefaultPlaceholder_Search");
        }
        if (this.canTranslate("General_DropdownBlank_NoSelection")) {
            this._setOuterPlaceholderAttr("General_DropdownBlank_NoSelection");
        }
        on(this.dropdownContainer, "keydown", lang.hitch(this, this._onKeydownDropdown));

        this._additionalRequestParameters = [];
        this._selectedValues = [];
        this.entries = [];

        this.PitHelper._structureFormat = this.dataFormat;

        this._setupEventListener();
        //this.checkValidity();

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.input, "multiselectInput", this.labelNode);
        this.setAllDataCyAttributes();
    }
    startup():void {
        super.startup.apply(this, arguments as any);

        if (this.url || this.callfunction) {
            if (this._loadTimeout != null) return;

            let bSuppress = undefined

            if (typeof (this._initialSuppressChange) == "boolean") {
                bSuppress = this._initialSuppressChange;
            }

            this.loadListValues(this._initialValue, bSuppress);
        }
    }
    destroy():void {
        super.destroy.apply(this, arguments as any);
    }

    public setAllDataCyAttributes() {
        this.setDataCyAttribute(this.openDropdownBtn, "multiselectOpenDropdownBtn");
        this.setDataCyAttribute(this.btnConfirm, "multiselectBtnConfirm");
        this.setDataCyAttribute(this.dropdownContainer, "multiselectDropdown");
        this.setDataCyAttribute(this.input, "multiselectInput");
        this.setDataCyAttribute(this.btnSelectAll, "multiselectBtnSelectAll");
        this.setDataCyAttribute(this.btnSelectNone, "multiselectBtnSelectNone");
        this.setDataCyAttribute(this.btnShowSelected, "multiselectBtnShowSelected");
        this.setDataCyAttribute(this.confirmDropdownBtn, "multiselectConfirmDropdownBtn");
    }

    //find the next node down with type HTMLInputElement, HTMLTextAreaElement,HTMLSelectElement or self
    private _findSelfOrNextInputElement(node: Node | null): HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | null {
        const start = node instanceof Element ? node : node?.parentElement ?? null;
        if (!start) return null;

        if (
            start instanceof HTMLInputElement ||
            start instanceof HTMLTextAreaElement ||
            start instanceof HTMLSelectElement
        ) {
            return start;
        }

        const match = start.querySelector('input, textarea, select');

        if (
            match instanceof HTMLInputElement ||
            match instanceof HTMLTextAreaElement ||
            match instanceof HTMLSelectElement
        ) {
            return match;
        }

        return null;
    }

}

export default mdsWidget(Multiselect);
